import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpRequest, HttpParams } from '@angular/common/http';
import { Observable, BehaviorSubject, EMPTY} from 'rxjs';
import { map, publishReplay, refCount } from 'rxjs/operators';

import * as d3 from 'd3';

/*import { Router, ActivatedRoute, NavigationExtras } from '@angular/router';
*/

import {mDeviceUsage, School, Year, Grade, Class, Subject, SchoolCategory, Country, Region, User, Role} from '../model/userUsage.model';

import { environment } from '../../environments/environment';
import { stringify } from '@angular/compiler/src/util';
import { JsonPipe } from '@angular/common';
import { Subscription } from 'rxjs';

@Injectable()
export class deviceUsageDataService {

  headers: any;
  options: any;

  private date$Filter = new BehaviorSubject<any>({
    startDate: '',
    endDate: ''
  });
  currentDateFilter = this.date$Filter.asObservable();

  private other$Filter = new BehaviorSubject<any>({});
  currentOtherFilters = this.other$Filter.asObservable();

  // device usage data
  private rawDeviceUsage$Data = new BehaviorSubject<mDeviceUsage[]>([]);
  readonly deviceUsage$Data = this.rawDeviceUsage$Data.asObservable();

  // overview tab section 2 Device Overview
  private rawDeviceOverview$Data = new BehaviorSubject<any[]>([]);
  readonly deviceOverview$Data = this.rawDeviceOverview$Data.asObservable();

  // device tab section 1 Tablet Overview
  private rawTabletOverview$Data = new BehaviorSubject<any[]>([]);
  readonly tabletOverview$Data = this.rawTabletOverview$Data.asObservable();
  private rawTabletUtilization$Data = new BehaviorSubject<any[]>([]);
  readonly tabletUtilization$Data = this.rawTabletUtilization$Data.asObservable();
  private rawTabletConnectivity$Data = new BehaviorSubject<any[]>([]);
  readonly tabletConnectivity$Data = this.rawTabletConnectivity$Data.asObservable();

  // device tab section 2 Laptop Overview
  private rawLaptopOverview$Data = new BehaviorSubject<any[]>([]);
  readonly laptopOverview$Data = this.rawLaptopOverview$Data.asObservable();
  private rawLaptopUtilization$Data = new BehaviorSubject<any[]>([]);
  readonly laptopUtilization$Data = this.rawLaptopUtilization$Data.asObservable();
  private rawLaptopConnectivity$Data = new BehaviorSubject<any[]>([]);
  readonly laptopConnectivity$Data = this.rawLaptopConnectivity$Data.asObservable();

  // section 3 User to Device Average
  private rawUserPerDevice$Data = new BehaviorSubject<number>(0);
  readonly userPerDevice$Data = this.rawUserPerDevice$Data.asObservable();
  private rawUserPerDeviceDaily$Data = new BehaviorSubject<any[]>([]);
  readonly userPerDeviceDaily$Data = this.rawUserPerDeviceDaily$Data.asObservable();

  // section 4 tablet daily use
  private rawTabletDaily$Data = new BehaviorSubject<any[]>([]);
  readonly tabletDaily$Data = this.rawTabletDaily$Data.asObservable();

  // section 5 laptop daily use
  private rawLaptopDaily$Data = new BehaviorSubject<any[]>([]);
  readonly laptopDaily$Data = this.rawLaptopDaily$Data.asObservable();

  // section 6 device inventory
  private rawDeviceInventory$Data = new BehaviorSubject<any[]>([]);
  readonly deviceInventory$Data = this.rawDeviceInventory$Data.asObservable();
  private dateFilter:Subscription;
  private invdateFilter:Subscription;
  constructor( private http: HttpClient) {
    const headersItem = new HttpHeaders({
      'Content-Type': 'application/json'
    });
    this.headers = headersItem;
  }

  setDateFilter(start, end?) {

    if (start) {
      if (start && end) {
        this.date$Filter.next(Object.assign({}, {
          startDate: start + 'T00:00:00Z',
          endDate: end + 'T00:00:00Z'
        }));
      } else {
        let startDate: string;
        let endDate: string;
        const curDate = new Date();
        endDate = curDate.getFullYear() + '-' + ('0' + (curDate.getMonth() + 1)).slice(-2) + '-' + ('0' + curDate.getDate()).slice(-2) + 'T00:00:00Z';

        let diffInHours: number = 0;
        if (start === '24Hours') {
          diffInHours = 24 * 3600;
        } else if (start === '7Days') {
          diffInHours = 7 * (24 * 3600);
        } else if (start === '30Days') {
          diffInHours = 30 * (24 * 3600);
        } else if (start === '90Days') {
          diffInHours = 90 * (24 * 3600);
        } else if (start === 'Year') {
          diffInHours = 365 * (24 * 3600);
        }

        const tmpDate = new Date(curDate.getTime() - (diffInHours * 1000));
        startDate = tmpDate.getFullYear() + '-' + ('0' + (tmpDate.getMonth() + 1)).slice(-2) + '-' + ('0' + tmpDate.getDate()).slice(-2) + 'T00:00:00Z';

        this.date$Filter.next(Object.assign({}, {
          startDate,
          endDate
        }));

      }
    }
  }

  setOtherFilter(filter: any) {
    if (filter) {
      this.other$Filter.next(Object.assign({}, filter));
    } else {
      this.other$Filter.next(Object.assign({}, EMPTY));
    }
  }


  // Get UserUsageData from server | HTTP GET
  loadDeviceUsageData() {
    let count = 0;
    // toto: add all data filter
    if(this.dateFilter){
      this.dateFilter.unsubscribe();
    }
    this.dateFilter = this.currentDateFilter.subscribe( data => {
      const startDate = data.startDate;
      const endDate = data.endDate;
      count=count+1;
      let URLSearchParams = new HttpParams();
      URLSearchParams = URLSearchParams.set('startDate', startDate);
      URLSearchParams = URLSearchParams.set('endDate', endDate);

      this.options = { headers: this.headers, params: URLSearchParams };
      //if(count==1){
      this.http.get(environment.dashAPI + '/devices', this.options).subscribe(data1 => {
        try {
          this.rawDeviceUsage$Data.next(Object.assign([], data1));
        } catch (err) {
          this.rawDeviceUsage$Data.next(Object.assign([], EMPTY));
          this.clearUserCache();
        }
      }, error => {
        this.rawDeviceUsage$Data.next(Object.assign([], EMPTY));
        this.clearUserCache();
      });
      //}
    });
    
  }

  // Clear configs
  clearUserCache() {
    this.rawDeviceUsage$Data.next(Object.assign([], EMPTY));
    this.rawDeviceOverview$Data.next(Object.assign([], EMPTY));

    this.rawTabletOverview$Data.next(Object.assign([], EMPTY));
    this.rawTabletUtilization$Data.next(Object.assign([], EMPTY));
    this.rawTabletConnectivity$Data.next(Object.assign([], EMPTY));
    this.rawLaptopOverview$Data.next(Object.assign([], EMPTY));
    this.rawLaptopUtilization$Data.next(Object.assign([], EMPTY));
    this.rawLaptopConnectivity$Data.next(Object.assign([], EMPTY));
    this.rawUserPerDevice$Data.next(0);
    this.rawUserPerDeviceDaily$Data.next(Object.assign([], EMPTY));
    this.rawDeviceInventory$Data.next(Object.assign([], EMPTY));
  }

  // overview tab and devices tab
  getDeviceOverviewData() {
    /* let filter = {};
    this.currentOtherFilters.subscribe( data => {
      //
      filter = data;
    }); */

    this.deviceUsage$Data.subscribe( data => {
      if (data && data.length > 0) {
        let filterredData: any[] = data;

        this.currentOtherFilters.subscribe( filter => {

          if (filter) {
            filterredData = data.filter(function(item){
              for (var key in filter) {
                if (item[key] === undefined || item[key] != filter[key]) {
                  return false;
                }
              }
              return true;
            });
          }

          if (filterredData && filterredData.length > 0) {

            const tmpData1 = d3.nest<mDeviceUsage, number>()
              .key(function(d: any) { return d.device_type; })
              .rollup(function(v) {
                return d3.sum(v, function(g: any) { return parseInt(g.no_of_device_deployed); });
              })
              .entries(filterredData);

            const tmpData2 = d3.nest<mDeviceUsage, number>()
              .key(function(d: any) { return d.device_type; })
              .rollup(function(v) {
                return d3.sum(v, function(g: any) { return parseInt(g.no_of_device_used); });
              })
              .entries(filterredData);

            //console.log("tmpData >>> " + JSON.stringify(tmpData1));
            var i;
            var tmpData = [];
            for (i = 0; i < tmpData1.length; i++){
              tmpData[i] = {};
                tmpData[i].id = tmpData1[i]['key'];
                tmpData[i].deployed = tmpData1[i]['value'];
                if (tmpData2[i]['value']) {
                  tmpData[i].used = tmpData2[i]['value'];
                }
                else {
                  tmpData[i].used = 0;
                }
            }
            this.rawDeviceOverview$Data.next(Object.assign([], tmpData));
          } else {
            this.rawDeviceOverview$Data.next(Object.assign([], EMPTY));
          }
        });
      } else {
        this.rawDeviceOverview$Data.next(Object.assign([], EMPTY));
      }
    });
  }

  // overview tab and devices tab
  getTabletOverviewData() {
    /* let filter = {};
    this.currentOtherFilters.subscribe( data => {
      //
      filter = data;
    }); */

    this.deviceUsage$Data.subscribe( data => {
      if (data && data.length > 0) {
        let filterredData: any[] = data;

        this.currentOtherFilters.subscribe( filter => {

          if (filter) {
            filterredData = data.filter(function(item){
              for (var key in filter) {
                if (item[key] === undefined || item[key] != filter[key]) {
                  return false;
                }
              }
              return true;
            });
          }

          if (filterredData && filterredData.length > 0) {
            const tmpData = d3.nest<mDeviceUsage, number>()
              .key(function(d: any) { return d.role.name; })
              .rollup(function(v) {
                return d3.sum(v, function(g: any) { return parseInt(g.no_of_logins); });
              })
              .entries(filterredData);
            //console.log("tmpData >>> " + JSON.stringify(tmpData));
            var i;
            var result: any[];
            for (i = 0; i < tmpData.length; i++){
                result[i] = {};
                result[i].id = tmpData[i]['key'];
                result[i].count = tmpData[i]['value'];
                delete tmpData[i].key;
                delete tmpData[i].value;
                delete tmpData[i].values;
            }
            this.rawTabletOverview$Data.next(Object.assign([], result));
          } else {
            this.rawTabletOverview$Data.next(Object.assign([], EMPTY));
          }
        });
      } else {
        this.rawTabletOverview$Data.next(Object.assign([], EMPTY));
      }
    });
  }

  // overview tab and devices tab
  getTabletOverviewUtilizationData() {
    /* let filter = {};
    this.currentOtherFilters.subscribe( data => {
      //
      filter = data;
    }); */
    let deviceType="";
    this.deviceUsage$Data.subscribe( data => {
      if (data && data.length > 0) {

        let tabletData = data.filter(function(item) {
          if (item.device_type == 'Tablet') {
            console.log("return true");
            deviceType = item.device_type;
            return true;
          }
          else{
            console.log("return false");
            return false;
          }
        });

        let filterredData: any[] = tabletData;
        if(deviceType == 'Tablet'){
            this.currentOtherFilters.subscribe( filter => {

            if (filter) {
              filterredData = tabletData.filter(function(item){
                for (var key in filter) {
                  if (item[key] === undefined || item[key] != filter[key]) {
                    return false;
                  }
                }
                return true;
              });
            }

            //console.log('filterred data - Tablet utilization >> ' + JSON.stringify(filterredData));
            if (filterredData && filterredData.length > 0) {
              const tmpData = [
                {
                'id': 'Deployed',
                'count': d3.sum(filterredData, function(g: any) { return parseInt(g.no_of_device_deployed); })
                },
                {
                  'id': 'Used',
                  'count': d3.sum(filterredData, function(g: any) { return parseInt(g.no_of_device_used); })
                  }
              ];

              //console.log("tmpData >>> " + JSON.stringify(tmpData));
              this.rawTabletUtilization$Data.next(Object.assign([], tmpData));
            } else {
              this.rawTabletUtilization$Data.next(Object.assign([], EMPTY));
            }
          });
        }
      } else {
        this.rawTabletUtilization$Data.next(Object.assign([], EMPTY));
      }
    });
  }

  // overview tab and devices tab
  getTabletOverviewConnectivityData() {
    /* let filter = {};
    this.currentOtherFilters.subscribe( data => {
      //
      filter = data;
    }); */
    let deviceType = "";
    this.deviceUsage$Data.subscribe( data => {
      if (data && data.length > 0) {

        let tabletData = data.filter(function(item) {
          if (item.device_type == 'Tablet') {
            deviceType =  item.device_type;
            return true;
          }
          else{
            return false;
          }
        });

        let filterredData: any[] = tabletData;
          if(deviceType == 'Tablet'){
            this.currentOtherFilters.subscribe( filter => {

              if (filter) {
                filterredData = data.filter(function(item){
                  for (var key in filter) {
                    if (item[key] === undefined || item[key] != filter[key]) {
                      return false;
                    }
                  }
                  return true;
                });
              }

              if (filterredData && filterredData.length > 0) {
                const total = d3.sum(filterredData, function(g: any) { return parseInt(g.no_of_ethernet_connection); }) + d3.sum(filterredData, function(g: any) { return parseInt(g.no_of_ethernet_connection); }) + d3.sum(filterredData, function(g: any) { return parseInt(g.no_of_mobile_data_connection); });
                const tmpData = [
                  {
                  'id': 'Ethernet/Wi-FI/SIM',
                  'count': d3.sum(filterredData, function(g: any) { return parseInt(g.no_of_ethernet_connection); }) + d3.sum(filterredData, function(g: any) { return parseInt(g.no_of_mobile_data_connection); }),
                  'total': total
                  },
                  {
                    'id': 'No Connection',
                    'count': d3.sum(filterredData, function(g: any) { return parseInt(g.no_of_noconnection); }),
                    'total': total
                    }
                ];
                this.rawTabletConnectivity$Data.next(Object.assign([], tmpData));
              } else {
                this.rawTabletConnectivity$Data.next(Object.assign([], EMPTY));
              }
            });
        }
      } else {
        this.rawTabletConnectivity$Data.next(Object.assign([], EMPTY));
      }
    });
  }

  // overview tab and devices tab
  getLaptopOverviewData() {
    /* let filter = {};
    this.currentOtherFilters.subscribe( data => {
      //
      filter = data;
    }); */

    this.deviceUsage$Data.subscribe( data => {
      if (data && data.length > 0) {
        let filterredData: any[] = data;

        this.currentOtherFilters.subscribe( filter => {

          if (filter) {
            filterredData = data.filter(function(item){
              for (var key in filter) {
                if (item[key] === undefined || item[key] != filter[key]) {
                  return false;
                }
              }
              return true;
            });
          }

          if (filterredData && filterredData.length > 0) {
            const tmpData = d3.nest<mDeviceUsage, number>()
              .key(function(d: any) { return d.role.name; })
              .rollup(function(v) {
                return d3.sum(v, function(g: any) { return parseInt(g.no_of_logins); });
              })
              .entries(filterredData);
            //console.log("tmpData >>> " + JSON.stringify(tmpData));
            var i;
            var result: any[];
            for (i = 0; i < tmpData.length; i++){
                result[i] = {};
                result[i].id = tmpData[i]['key'];
                result[i].count = tmpData[i]['value'];
                delete tmpData[i].key;
                delete tmpData[i].value;
                delete tmpData[i].values;
            }
            this.rawLaptopOverview$Data.next(Object.assign([], result));
          } else {
            this.rawLaptopOverview$Data.next(Object.assign([], EMPTY));
          }
        });
      } else {
        this.rawLaptopOverview$Data.next(Object.assign([], EMPTY));
      }
    });
  }

  // overview tab and devices tab
  getLaptopOverviewUtilizationData() {
    /* let filter = {};
    this.currentOtherFilters.subscribe( data => {
      //
      filter = data;
    }); */
    let deviceType = "";
    this.deviceUsage$Data.subscribe( data => {
      if (data && data.length > 0) {
        //let data: any[] = [...data];

        let laptopData = data.filter(function(item) {
          if (item.device_type == 'Laptop') {
            deviceType = item.device_type;
           return true;
          }
          return false;
        });

        let filterredData: any[] = laptopData;
        if(deviceType == 'Laptop'){
        this.currentOtherFilters.subscribe( filter => {

          if (filter) {
            filterredData = laptopData.filter(function(item){
              for (var key in filter) {
                if (item[key] === undefined || item[key] != filter[key]) {
                  return false;
                }
              }
              return true;
            });
          }

          //console.log('filterred data - Laptop utilization >> ' + JSON.stringify(filterredData));
          if (filterredData && filterredData.length > 0) {
            const tmpData = [
              {
                'id': 'Deployed',
                'count': d3.sum(filterredData, function(g: any) { return parseInt(g.no_of_device_deployed); })
              },
              {
                'id': 'Used',
                'count': d3.sum(filterredData, function(g: any) { return parseInt(g.no_of_device_used); })
              }
            ];
            //console.log("tmpData >>> " + JSON.stringify(tmpData));
            this.rawLaptopUtilization$Data.next(Object.assign([], tmpData));
          } else {
            this.rawLaptopUtilization$Data.next(Object.assign([], EMPTY));
          }
        });
      }
      } else {
        this.rawLaptopUtilization$Data.next(Object.assign([], EMPTY));
      }
    });
  }

  // overview tab and devices tab
  getLaptopOverviewConnectivityData() {
    /* let filter = {};
    this.currentOtherFilters.subscribe( data => {
      //
      filter = data;
    }); */
let deviceType = "";
    this.deviceUsage$Data.subscribe( data => {
      if (data && data.length > 0) {
        let laptopData = data.filter(function(item) {
          if (item.device_type == 'Laptop') {
            deviceType = item.device_type;
            return true;
          }
          return false;
        });

        let filterredData: any[] = laptopData;
        if(deviceType == 'Laptop'){
        this.currentOtherFilters.subscribe( filter => {

          if (filter) {
            filterredData = data.filter(function(item){
              for (var key in filter) {
                if (item[key] === undefined || item[key] != filter[key]) {
                  return false;
                }
              }
              return true;
            });
          }

          if (filterredData && filterredData.length > 0) {
            const total = d3.sum(filterredData, function(g: any) { return parseInt(g.no_of_ethernet_connection); }) + d3.sum(filterredData, function(g: any) { return parseInt(g.no_of_ethernet_connection); }) + d3.sum(filterredData, function(g: any) { return parseInt(g.no_of_mobile_data_connection); });
            const tmpData = [
              {
              'id': 'Ethernet/Wi-FI/SIM',
              'count': d3.sum(filterredData, function(g: any) { return parseInt(g.no_of_ethernet_connection); }) + d3.sum(filterredData, function(g: any) { return parseInt(g.no_of_mobile_data_connection); }),
              'total': total
              },
              {
                'id': 'No Connection',
                'count': d3.sum(filterredData, function(g: any) { return parseInt(g.no_of_noconnection); }),
                'total': total
                }
            ];
            this.rawLaptopConnectivity$Data.next(Object.assign([], tmpData));
          } else {
            this.rawLaptopConnectivity$Data.next(Object.assign([], EMPTY));
          }
        });
      }
      } else {
        this.rawLaptopConnectivity$Data.next(Object.assign([], EMPTY));
      }
    });
  }

  // device tab
  getUserToDeviceAvgData() {
    /* let filter = {};
    this.currentOtherFilters.subscribe( data => {
      //
      filter = data;
    }); */

    this.deviceUsage$Data.subscribe( data => {
      if (data && data.length > 0) {
        //let data: any[] = [...data];

        let filterredData: any[] = data;

        this.currentOtherFilters.subscribe( filter => {

          if (filter) {
            filterredData = data.filter(function(item){
              for (var key in filter) {
                if (item[key] === undefined || item[key] != filter[key]) {
                  return false;
                }
              }
              return true;
            });
          }

          //console.log('filterred data - Laptop utilization >> ' + JSON.stringify(filterredData));
          if (filterredData && filterredData.length > 0) {
            const deployed_devices = d3.mean(filterredData, function(g: any) { return parseInt(g.user_per_device); });
            //console.log("tmpData >>> " + JSON.stringify(tmpData));
            this.rawUserPerDevice$Data.next(Math.ceil(deployed_devices))  ;
          } else {
            this.rawUserPerDevice$Data.next(0);
          }
        });
      } else {
        this.rawUserPerDevice$Data.next(0);
      }
    });
  }

  getUserToDeviceTrendData() {
    /* let filter = {};
    this.currentOtherFilters.subscribe( data => {
      //
      filter = data;
    }); */

    this.deviceUsage$Data.subscribe( data => {
      if (data && data.length > 0) {
        //let data: any[] = [...data];

        let filterredData: any[] = data;

        this.currentOtherFilters.subscribe( filter => {

          if (filter) {
            filterredData = data.filter(function(item){
              for (var key in filter) {
                if (item[key] === undefined || item[key] != filter[key]) {
                  return false;
                }
              }
              return true;
            });
          }

          //console.log('filterred data - Laptop utilization >> ' + JSON.stringify(filterredData));
          if (filterredData && filterredData.length > 0) {
            const tmpData = d3.nest<mDeviceUsage, number>()
              .key(function(d: any) { return d.activity_date; })
              .rollup(function(v) {
                return d3.sum(v, function(g: any) { return parseInt(g.user_per_device); });
              })
              .entries(filterredData);
            //console.log("tmpData >>> " + JSON.stringify(tmpData));
            var i;
            var result: any = [];
            for (i = 0; i < tmpData.length; i++){
              let from: any = tmpData[i]['key'].split('-');
              const mydate = new Date(from[2], from[1] - 1, from[0], 0, 0, 0, 0);
              result[i] = {};
              //result[i].data = {};
              result[i].date = mydate;
              result[i].count = tmpData[i]['value'];
              delete tmpData[i].key;
              delete tmpData[i].value;
            }

            if (result && result.length) {
              result.sort((a, b) => new Date(a.date).getTime() - new Date(b.date).getTime());
            }
            //const avg_user_per_day = d3.mean(result, function(g: any) { return parseInt(g.user_per_device); });

            //console.log('userperdevice result  >>> ' + JSON.stringify([{'id': 'UserDeviceTrend', 'values': result}]));
            this.rawUserPerDeviceDaily$Data.next(Object.assign([], [{'id': 'UserDeviceTrend', 'values': result}]))  ;
          } else {
            this.rawUserPerDeviceDaily$Data.next(Object.assign([], EMPTY));
          }
        });
      } else {
        this.rawUserPerDeviceDaily$Data.next(Object.assign([], EMPTY));
      }
    });
  }

  // device tab
  getTabletDailyUseData() {
    /* let filter = {};
    this.currentOtherFilters.subscribe( data => {
      //
      filter = data;
    }); */
let deviceType = "";
    this.deviceUsage$Data.subscribe( data => {
      if (data && data.length > 0) {

        let tabletData = data.filter(function(item) {
          if (item.device_type == 'Tablet') {
            deviceType =  item.device_type;
            return true;
          }
          else{
            return false;
          }
        });

        let filterredData: any[] = tabletData;
        if(deviceType == 'Tablet'){
            this.currentOtherFilters.subscribe( filter => {

              if (filter) {
                filterredData = data.filter(function(item){
                  for (var key in filter) {
                    if (item[key] === undefined || item[key] != filter[key]) {
                      return false;
                    }
                  }
                  return true;
                });
              }

              if (filterredData && filterredData.length > 0) {
                const tmpData = d3.nest<mDeviceUsage, number>()
                  .key(function(d: any) { return d.activity_date; })
                  .entries(filterredData);
                //console.log("tmpData >>> " + JSON.stringify(tmpData));
                var i;
                var result: any[] = [];
                for (i = 0; i < tmpData.length; i++){
                    let from: any = tmpData[i]['key'].split('-');
                    const mydate = new Date(from[2], from[1] - 1, from[0], 0, 0, 0, 0);
                    result[i] = {};
                    //result[i].data = {};
                    result[i].date = mydate;
                    result[i]['Ethernet/Wi-fi/SIM'] = d3.sum(tmpData[i]['values'], function(g: any) { return parseInt(g.no_of_ethernet_connection); }) + d3.sum(tmpData[i]['values'], function(g: any) { return parseInt(g.no_of_mobile_data_connection); });
                    result[i]['No Connection'] = d3.sum(tmpData[i]['values'], function(g: any) { return parseInt(g.no_of_noconnection); });
                }
                this.rawTabletDaily$Data.next(Object.assign([], result));
              } else {
                this.rawTabletDaily$Data.next(Object.assign([], EMPTY));
              }
            });
        }
      } else {
        this.rawTabletDaily$Data.next(Object.assign([], EMPTY));
      }
    });
  }

  // device tab
  getLaptopDailyUseData() {
    /* let filter = {};
    this.currentOtherFilters.subscribe( data => {
      //
      filter = data;
    }); */
    let deviceType = "";
    this.deviceUsage$Data.subscribe( data => {
      if (data && data.length > 0) {

        let laptopData = data.filter(function(item) {
          if (item.device_type == 'Laptop') {
            deviceType = item.device_type;
            return true;
          }
          else{
            return false;
          }
        });

        let filterredData: any[] = laptopData;
        if(deviceType == 'Laptop'){
        this.currentOtherFilters.subscribe( filter => {

          if (filter) {
            filterredData = data.filter(function(item){
              for (var key in filter) {
                if (item[key] === undefined || item[key] != filter[key]) {
                  return false;
                }
              }
              return true;
            });
          }

          if (filterredData && filterredData.length > 0) {
            const tmpData = d3.nest<mDeviceUsage, number>()
              .key(function(d: any) { return d.activity_date; })
              .entries(filterredData);
            //console.log("tmpData >>> " + JSON.stringify(tmpData));
            var i;
            var result: any[] = [];
            for (i = 0; i < tmpData.length; i++){
              let from: any = tmpData[i]['key'].split('-');
              const mydate = new Date(from[2], from[1] - 1, from[0], 0, 0, 0, 0);
                result[i] = {};
                //result[i].data = {};
                result[i].date = mydate;
                result[i]['Ethernet/Wi-fi/SIM'] = d3.sum(tmpData[i]['values'], function(g: any) { return parseInt(g.no_of_ethernet_connection); }) + d3.sum(tmpData[i]['values'], function(g: any) { return parseInt(g.no_of_mobile_data_connection); });
                result[i]['No Connection'] = d3.sum(tmpData[i]['values'], function(g: any) { return parseInt(g.no_of_noconnection); });
            }
            this.rawLaptopDaily$Data.next(Object.assign([], result));
          } else {
            this.rawLaptopDaily$Data.next(Object.assign([], EMPTY));
          }
        });
        }
      } else {
        this.rawLaptopDaily$Data.next(Object.assign([], EMPTY));
      }
    });
  }


  // device tab
  getDeviceInventoryData() {
    // toto: add all data filter
    let count=0;
    if(this.invdateFilter){
      this.invdateFilter.unsubscribe();
    }
    this.invdateFilter = this.currentDateFilter.subscribe( data => {
      const startDate = data.startDate;
      const endDate = data.endDate;
      let URLSearchParams = new HttpParams();
      count= count+1;
      URLSearchParams = URLSearchParams.set('startDate', startDate);
      URLSearchParams = URLSearchParams.set('endDate', endDate);

      this.options = { headers: this.headers, params: URLSearchParams };
     // if(count==1){
      this.http.get(environment.dashAPI + '/inventory', this.options).subscribe(data1 => {
        try {
          this.rawDeviceInventory$Data.next(Object.assign([], data1));
        } catch (err) {
          this.rawDeviceInventory$Data.next(Object.assign([], EMPTY));
          this.clearUserCache();
        }
      }, error => {
        //console.log('Could not load todos.');
        this.rawDeviceInventory$Data.next(Object.assign([], EMPTY));
        this.clearUserCache();
      });
    //}
    });
  }

  //end
}
